import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import dayjs from "dayjs";
import { cloneDeep } from "lodash";
import cx from "classnames";
// eslint-disable-next-line no-restricted-imports
// import { MedicaidToast } from "../components/MedicaidToast";
import { isMobile } from "react-device-detect";
// eslint-disable-next-line no-restricted-imports
import { Footer } from "../components/Footer/FooterV2";
import stylesV2 from "./AppointmentBookingStartV2.module.scss";
import stylesV3 from "./AppointmentBookingStartV3.module.scss";
import { WeekTimeSlots } from "./WeekTimeSlots";
import { OfficeCard } from "./OfficeCard";
import { DoctorCard } from "./DoctorCard";
import { NearbyOffice } from "./NearbyOffice";
import { MobileView } from "./MobileView";
import { TrustBuildCard } from "./TrustBuildCard";
import { AppointmentExamDetails } from "./AppointmentExamDetails";
import { AppointmentSelectReturnStatus } from "./AppointmentSelectReturnStatus";
import { AppointmentAccountSetup } from "./AppointmentAccountSetup";
import { AppointmentReviewPopUpV2 } from "./AppointmentReviewPopUpV2";
import { useTrackEvent } from "hooks/useTrackEvent";
import { FooterPortal } from "components/Footer/Footer";
import { RootState } from "app/store";
import { Modal, ReviewModal } from "components/Modal";
import {
  setAppointmentData,
  selectAppointmentData,
  selectIsEditForm,
  selectEditSection,
} from "features/appointmentDataSlice";
import {
  resetTimeSlots,
  setTimeSlots,
  selectTimeslots,
  selectIstimeSlotLoaded,
  selectUpcomingTimeslotsForOfficeByDate,
} from "features/scheduling/timeSlotsSlice";
import { Button, ButtonRole } from "components/Button";
import { LayoutV2 } from "features/layout";
import { LayoutV3 } from "features/layout/LayoutV3";
import { API_DATE_FORMAT } from "api/constants";
import { getSlotMetaData } from "api/getSlotMetaData";
import { Office } from "types/office";
import { ExamType } from "types/examType";
import { useQueryParam } from "hooks/useQueryParam";
import { PatientReturnStatus } from "types/patientReturnStatus";
import { WithOffice } from "components/WithOffice";
import { Doctor } from "types/doctor";
import { WithOfficeDoctors } from "components/WithOfficeDoctors";
import * as paths from "features/routing/paths";
import {
  fetchNearbyOffices,
  selectNearbyOffices,
  selectNearbyOfficeAvailabilitySlots,
  selectNearbyOfficeLoadingState,
} from "features/scheduling/nearbyOfficesSlice";
import {
  setOfficeAvailability,
  fetchOfficeAvailability,
} from "features/scheduling/availabilitySummarySlice";
import { updateSelectedAppointment } from "features/scheduling/appointmentCreationSlice";
//import { fetchFirstAvailability } from "features/scheduling/firstAvailabilitySlice";
//import { areFirstAvailableApptsByDefaultEnabled } from "featureFlags/areFirstAvailableApptsByDefaultEnabled";
import { Slot } from "types/slot";
import {
  isEmail,
  isValidTLDLength,
  acceptableCharacters,
} from "utils/emailValidation";
import { isValidDateOfBirth } from "utils/dateOfBirthValidation";
import { isValidDateOfBirthVEH } from "utils/dateOfBirthValidationVEH";
import { isValidDOBRestrictVEH } from "utils/isValidDOBRestrictVEH";
//import { isValidDateOfBirthVEH } from "utils/dateOfBirthValidationVEH";
import { isValidPhoneNumber } from "utils/phoneNumberValidation";
import successCircle from "images/success-circle-ticker.svg";
import errorCircle from "images/error-circle-cross.svg";
import closeIcon from "images/closeIcon.svg";
import editIcon from "images/edit.svg";
import arrowLeft from "images/vwo/arrow-left.svg";
import iconBaby from "images/vwo/icon-baby.svg";
import iconClip from "images/vwo/icon-clip.svg";
import iconSmile from "images/vwo/icon-smile.svg";
import iconReturn from "images/vwo/return.svg";
import vehPatientImg from "images/vwo/VEH-Patient.png";
import { useSchedulingABVariant } from "../utils/useSchedulingABVariant";
import { areExtendedPatientNameFieldsEnabled } from "featureFlags/areExtendedPatientNameFieldsEnabled";
import { isValidPatientName } from "utils/patientNameValidation";

const aria = {
  labelledby: "appointment-exam-details-modal-label",
  describedby: "appointment-exam-details-modal-description",
};

declare let vehDisclaimerHide: string;

function useScreenSize() {
  const [screenSize, setScreenSize] = React.useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return screenSize;
}

interface UnconnectedAppointmentBookingStartProps {
  officeForThisAppointment: Office;
  officeId: string;
  doctors: Doctor[];
}

const DESKTOP_BREAKPOINT = 992;
const DEFAULT_STICKY_TOP = 10;
const STICKY_STOP_GAP = 10;

interface StickyPositionParams {
  isDesktop: boolean;
  isStickyActive: boolean;
  scrollY: number;
  sectionTop: number;
  stickyHeight: number;
  stopAnchorTop: number | null;
}

interface StickyPositionResult {
  top: number;
}

export const getStickyPosition = ({
  isDesktop,
  isStickyActive,
  scrollY,
  sectionTop,
  stickyHeight,
  stopAnchorTop,
}: StickyPositionParams): StickyPositionResult | undefined => {
  if (!isDesktop || !isStickyActive) {
    return undefined;
  }

  if (!stickyHeight || stopAnchorTop === null) {
    return {
      top: DEFAULT_STICKY_TOP,
    };
  }

  // Highest document position where the rail bottom still stops above the
  // review tooltip / review-details button.
  const maxTopInDocument = stopAnchorTop - stickyHeight - STICKY_STOP_GAP;
  // Pin the rail near the top of the viewport so the "Selected Office" header
  // stays in view as the page auto-scrolls.
  const desiredTopInDocument = scrollY + DEFAULT_STICKY_TOP;

  // Follow the viewport while scrolling, but stop once the rail bottom reaches
  // the tooltip so it never scrolls past / is covered by it.
  const topInDocument = Math.min(desiredTopInDocument, maxTopInDocument);

  // `top` is relative to the positioned `stickySection` wrapper, so convert the
  // document position back into wrapper-relative coordinates.
  return {
    top: Math.max(0, topInDocument - sectionTop),
  };
};

export const UnconnectedAppointmentBookingStart: React.FC<
  UnconnectedAppointmentBookingStartProps
> = ({ officeForThisAppointment, officeId, doctors }) => {
  const { formattedPhone, officeUid } = officeForThisAppointment;
  const [eyeExam, setEyeExam] = React.useState<undefined | ExamType>(undefined);
  const [selectedDoctor, setSelectedDoctor] = React.useState<
    undefined | Doctor
  >(undefined);
  const [selectedSlot, setSelectedSlot] = React.useState<undefined | Slot>(
    undefined
  );
  const [vehSelectedSlot, setVehSelectedSlot] = React.useState<
    undefined | Slot
  >(undefined);
  const dummyPatientDetails = {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    dateOfBirth: "",
    smsOptInNotices: true,
    smsOptInPromos: true,
  };
  const [patientDetails, setPatientDetails] =
    React.useState<any>(dummyPatientDetails);
  const [patientType, setPatientType] = React.useState<
    undefined | PatientReturnStatus
  >(undefined);
  const [vehDoctorTerms, setVehDoctorTerms] = React.useState<boolean>(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const { trackEvent } = useTrackEvent();
  const [searchDateOrNull, setSearchDate] = useQueryParam("date", null);
  const [vehpop] = useQueryParam("vehpop", "1");
  const [executeOnce, setExecuteOnce] = React.useState(false);
  const [executeAvailOnce, setExecuteAvailOnce] = React.useState(false);
  const [executeGTMStep, setExecuteGTMStep] = React.useState(false);
  const [newDateArr, setNewDateArr] = React.useState({});
  const [firstAvailDocs, setFirstAvailDocs] = React.useState({});
  const [showFeatureOffice, setShowFeatureOffice] = React.useState(false);
  const [dataPush, setDataPush] = React.useState(false);
  const searchDate = searchDateOrNull || dayjs().format(API_DATE_FORMAT);
  const appoinmentData = useSelector(selectAppointmentData);
  const isEditForm = useSelector(selectIsEditForm);
  const editSection = useSelector(selectEditSection);
  const [nextButton, setNextButton] = React.useState(true);
  const examType = ExamType.Contacts;
  const patientReturnStatus = PatientReturnStatus.New;
  const WeekTimeSlotsRef = React.useRef<null | HTMLDivElement>(null);
  const examTypeRef = React.useRef<null | HTMLDivElement>(null);
  const patientTypeRef = React.useRef<null | HTMLDivElement>(null);
  const patientDetailsRef = React.useRef<null | HTMLDivElement>(null);
  const stickySectionRef = React.useRef<null | HTMLDivElement>(null);
  const stickyRailRef = React.useRef<null | HTMLDivElement>(null);
  const desktopEmailRowRef = React.useRef<null | HTMLDivElement>(null);
  const reviewActionRef = React.useRef<null | HTMLDivElement>(null);
  const reviewTooltipRef = React.useRef<null | HTMLDivElement>(null);
  const [restrictVehTerms, setRestrictVehTerms] =
    React.useState<boolean>(false);
  const [showReview, setShowReview] = React.useState<boolean>(false);
  const [pageSection, setPageSection] = React.useState<string>("TIMESLOT");
  const [editSectionModal, seteditSectionModal] = React.useState<string>(null);
  const [scrollPercentage, setScrollPercentage] = React.useState<number>(0);
  const [stickyPosition, setStickyPosition] = React.useState<
    StickyPositionResult | undefined
  >();
  const [newDesignQuery] = useQueryParam("newDesign", null);
  const [rslb] = useQueryParam("rslb", "false");
  const [slotMetaData, setSlotMetaData] = React.useState({});
  const screenSize = useScreenSize();
  const { isV3 } = useSchedulingABVariant();
  const newDesign = newDesignQuery || (isV3 ? "true" : null);
  const useClassicStartAvailabilityLayout = false;
  const Layout = isV3 ? LayoutV3 : LayoutV2;
  const styles = isV3 ? stylesV3 : stylesV2;
  const nameMaxLength = areExtendedPatientNameFieldsEnabled() ? 30 : 20;
  const stickyActive = selectedSlot !== undefined && scrollPercentage > 4.3;
  const isDesktop = screenSize >= DESKTOP_BREAKPOINT && !isMobile;

  useEffect(() => {
    dispatch(setTimeSlots([]));
    window.scrollTo(0, 0);
  }, [dispatch]);

  useEffect(() => {
    if (doctors.length === 0) {
      return;
    }
    if (!executeOnce) {
      dispatch(
        fetchOfficeAvailability({
          officeId,
          searchDate,
          examType,
          doctorIds: doctors.map((doctor) => doctor.id),
          patientReturnStatus,
          version: 2,
          rsl: rslb === "false" ? true : false,
        })
      );

      const getMetaData = async () => {
        const startDate = dayjs().format(API_DATE_FORMAT);
        const endDate = dayjs(startDate).add(49, "day").format(API_DATE_FORMAT);
        const slots_meta_data = await getSlotMetaData({
          officeId,
          startDate,
          endDate,
          examType,
          doctorIds: doctors.map((doctor) => doctor.id),
          patientReturnStatus,
          rsl: true,
        });
        //console.log(slots_meta_data);
        setSlotMetaData(slots_meta_data);
      };
      if (rslb === "false") {
        getMetaData();
      }
    }
  }, [
    dispatch,
    searchDate,
    officeId,
    doctors,
    examType,
    patientReturnStatus,
    appoinmentData,
    executeOnce,
    isEditForm,
    trackEvent,
    rslb,
  ]);

  useEffect(() => {
    if (!executeOnce && isEditForm) {
      const appData = cloneDeep(appoinmentData);
      // eslint-disable-next-line react-hooks/exhaustive-deps
      officeForThisAppointment = appData["office"];
      setPatientDetails(appData["patientDetails"]);
      if (editSection && editSection === "patientDetails") {
        setTimeout(() => {
          patientDetailsRef?.current?.scrollIntoView();
        }, 1);
      }
      setEyeExam(appData["eyeExam"]);
      setPatientType(appData["patientType"]);
      if (editSection && editSection === "timeSlot") {
        setSelectedDoctor(undefined);
        setSelectedSlot(undefined);
      } else {
        setSelectedDoctor(appData["doctor"]);
        setSelectedSlot(appData["timeSlot"]);
      }
    }
    setExecuteOnce(true);
  }, [
    setSelectedDoctor,
    setSelectedSlot,
    setExecuteOnce,
    executeOnce,
    isEditForm,
  ]);
  /*
  useEffect(() => {
    if (doctors.length === 0) {
      return;
    }
    if (areFirstAvailableApptsByDefaultEnabled()) {
      dispatch(
        fetchFirstAvailability({
          officeId,
          examType,
          doctorIds: doctors.map((doctor) => doctor.id),
          patientReturnStatus,
        })
      );
    }
  }, [dispatch, officeId, examType, doctors, patientReturnStatus]);

  */

  // const { isLoading } = useGetNearbyOfficesWithoutAvailabilityQuery(officeId);

  const isLoading = useSelector((state: RootState) =>
    selectNearbyOfficeLoadingState(state)
  );
  const nearbyOffices = useSelector((state: RootState) =>
    selectNearbyOffices(state, officeId)
  );
  const nearbyOfficesAvailabilitySlots = useSelector((state: RootState) =>
    selectNearbyOfficeAvailabilitySlots(state)
  );

  const isSlotLoaded = useSelector((state: RootState) =>
    selectIstimeSlotLoaded(state)
  );
  const timeslots = useSelector((state: RootState) => selectTimeslots(state));
  const slotsByDoctor = useSelector((state: RootState) =>
    selectUpcomingTimeslotsForOfficeByDate(state, officeForThisAppointment.id)
  );
  useEffect(() => {
    if (isSlotLoaded && !executeGTMStep) {      
      const doctorsDayStart = doctors
        .filter((doctor) => slotsByDoctor[doctor.id])
        .map((doctor) => Object.keys(slotsByDoctor[doctor.id])[0])
        .filter(Boolean);
      let weekSlotCount = 0;
      doctorsDayStart.sort(function (a, b) {
        return dayjs(a) - dayjs(b);
      });
      const weekCalendar: any[] = [];
      ["0", "1", "2", "3", "4", "5", "6"].map((i) =>
        weekCalendar.push(
          dayjs(searchDate).add(parseInt(i), "day").format(API_DATE_FORMAT)
        )
      );
      const doctorIds = {};
      const firstAvailDoctors = {};
      for (const doctor of doctors) {
        doctorIds[doctor.id] = [null, doctor.offersVEH ? 1 : 0];
      }
      let vehSlots = 0;
      let totalSlots = 0;
      if (timeslots.length > 0) {
        const nowAsString = dayjs()
          .startOf("minute")
          .tz(timeslots[0]["timeZoneName"])
          .format("YYYY-MM-DD HH:mm:ss");
        // eslint-disable-next-line react-hooks/exhaustive-deps
        for (const slotDetails of timeslots) {
          const doctorId = slotDetails.doctorId;
          if (!doctorIds[doctorId]) continue;
          if (slotDetails.date === doctorsDayStart[0]) {
            if (nowAsString < `${slotDetails.date} ${slotDetails.startTime}`) {
              totalSlots++;
              if (doctorIds[doctorId][1]) vehSlots++;
              if (doctorIds[doctorId][0] === null) {
                doctorIds[doctorId][0] = 1;
                if (typeof firstAvailDoctors[doctorId] === "undefined")
                  firstAvailDoctors[doctorId] = slotDetails;
              } else {
                doctorIds[doctorId][0] = doctorIds[doctorId][0] + 1;
              }
            }
          }
          if (nowAsString < `${slotDetails.date} ${slotDetails.startTime}`) {
            if (typeof newDateArr[slotDetails.date] === "undefined") {
              newDateArr[slotDetails.date] = {};
              if (
                typeof newDateArr[slotDetails.date][doctorId] === "undefined"
              ) {
                newDateArr[slotDetails.date][doctorId] = [
                  1,
                  "available",
                  slotDetails.date,
                ];
                if (typeof firstAvailDoctors[doctorId] === "undefined")
                  firstAvailDoctors[doctorId] = slotDetails;
              }
            } else if (
              typeof newDateArr[slotDetails.date][doctorId] === "undefined"
            ) {
              newDateArr[slotDetails.date][doctorId] = [
                1,
                "available",
                slotDetails.date,
              ];
              if (typeof firstAvailDoctors[doctorId] === "undefined")
                  firstAvailDoctors[doctorId] = slotDetails;
            } else {
              newDateArr[slotDetails.date][doctorId][0]++;
            }
          }
          if (weekCalendar[6] >= slotDetails.date) {
            weekSlotCount = weekSlotCount + 1;
          }
        }
        setNewDateArr(newDateArr);
        setFirstAvailDocs(firstAvailDoctors);
        if (weekSlotCount < 6) setShowFeatureOffice(true);
      }
      if (
        doctors.length === 0 ||
        timeslots.length === 0 ||
        (doctorsDayStart.length > 0 &&
          !weekCalendar.includes(doctorsDayStart[0]))
      ) {
        trackEvent("step-1-scheduler-enter", {
          location: officeId,
          logicalId: officeForThisAppointment.logicalId,
          office_type: officeForThisAppointment.offersVEH
            ? "VEH"
            : "Traditional",
          total_slots: 0,
          veh_slots: 0,
          traditional_slots: 0,
          SVT: "RS",
        });
        setExecuteGTMStep(true);
      } else {
        //console.log("step 1");
        /*console.log(
          officeId,
          officeForThisAppointment.offersVEH ? "VEH" : "Traditional",
          totalSlots,
          vehSlots,
          totalSlots - vehSlots
        );*/
        trackEvent("step-1-scheduler-enter", {
          location: officeId,
          logicalId: officeForThisAppointment.logicalId,
          office_type: officeForThisAppointment.offersVEH
            ? "VEH"
            : "Traditional",
          total_slots: totalSlots,
          veh_slots: vehSlots,
          traditional_slots: totalSlots - vehSlots,
          SVT: "RS",
        });
        setExecuteGTMStep(true);
      }
    }
  }, [
    isSlotLoaded,
    officeId,
    trackEvent,
    officeForThisAppointment,
    timeslots,
    doctors,
    searchDate,
    slotsByDoctor,
    executeGTMStep,
    newDateArr,
    firstAvailDocs,
  ]);
  useEffect(() => {
    if (!isEditForm)
      dispatch(fetchNearbyOffices({ officeId, examType, patientReturnStatus }));
  }, [dispatch, officeId, examType, patientReturnStatus, isEditForm]);

  const onSelectionTimeSlot = (type: string, value: Slot) => {
    let doctorCache: Doctor | undefined;
    doctors.map((doctor) => {
      if (value.doctorId === doctor.id) {
        doctorCache = doctor;
        setSelectedDoctor(doctor);
      }
    });
    const hideQP =
      vehDisclaimerHide === "true" || vehpop === "2" || vehpop === "true";
    if (doctorCache?.offersVEH && 
        !officeForThisAppointment.hideVEHdisclaimer) {
      setVehDoctorTerms(true);
      setVehSelectedSlot(value);
    } else if (
      doctorCache?.offersVEH &&
      officeForThisAppointment.hideVEHdisclaimer &&
      !hideQP
    ) {
        setVehDoctorTerms(true);
        setVehSelectedSlot(value);
    } else {
      setSelectedSlot(value);
      dispatch(
        updateSelectedAppointment({
          officeId,
          officeUid,
          ...value,
        })
      );
      setTimeout(() => {
        examTypeRef?.current?.scrollIntoView();
      }, 10);
      setDataPush(false);
    }
    //isFormValidation(patientDetails);
    isFormValidation({
      eyeExam: eyeExam,
      patientType: patientType,
      selectedDoctor: selectedDoctor,
      selectedSlot: value,
      patientDetails: patientDetails,
    });
    trackEvent("step-2-scheduler-start", {
      location: officeId,
      logicalId: officeForThisAppointment.logicalId,
    });

    trackEvent("step-5-selected-appointment-time", {
      location: officeId,
      logicalId: officeForThisAppointment.logicalId,
      selected_type: eyeExam,
      slot_type: doctorCache?.offersVEH ? "VEH" : "Traditional",
      patient_type: patientType,
      doctorId: doctorCache?.id,
    });
  };

  const onSelectionExamType = (type: string, value: ExamType) => {
    setEyeExam(value);
    /* some delay when popup close */
    setTimeout(() => {
      patientTypeRef?.current?.scrollIntoView();
      //isFormValidation(patientDetails);
      isFormValidation({
        eyeExam: value,
        patientType: patientType,
        selectedDoctor: selectedDoctor,
        selectedSlot: selectedSlot,
        patientDetails: patientDetails,
      });
      trackEvent("step-3-selected-eyewear-type", {
        location: officeId,
        logicalId: officeForThisAppointment.logicalId,
        selected_type: value,
        slot_type: selectedDoctor?.offersVEH ? "VEH" : "Traditional",
        patient_type: patientType,
        doctorId: selectedDoctor?.id,
      });
    }, 10);
    setDataPush(false);
  };

  const onSelectionPatientType = (type: string, value: PatientReturnStatus) => {
    setPatientType(value);
    setTimeout(() => {
      patientDetailsRef?.current?.scrollIntoView();
      //isFormValidation(patientDetails);
      isFormValidation({
        eyeExam: eyeExam,
        patientType: value,
        selectedDoctor: selectedDoctor,
        selectedSlot: selectedSlot,
        patientDetails: patientDetails,
      });
      trackEvent("step-4-selected-patient-type", {
        location: officeId,
        logicalId: officeForThisAppointment.logicalId,
        selected_type: eyeExam,
        slot_type: selectedDoctor?.offersVEH ? "VEH" : "Traditional",
        patient_type: value,
        doctorId: selectedDoctor?.id,
      });
    }, 10);
    setDataPush(false);
  };

  const onRestrictVEHSelection = () => {
    setRestrictVehTerms(true);
  };

  const onPatientEdit = () => {    
    closeReview();
    patientDetailsRef?.current?.scrollIntoView();    
  }

  const onEditTimeSlot = () => {
    setSelectedDoctor(undefined);
    setSelectedSlot(undefined);
    closeReview();
    setTimeout(() => {
      isFormValidation({
        eyeExam: eyeExam,
        patientType: patientType,
        selectedDoctor: selectedDoctor,
        selectedSlot: selectedSlot,
        patientDetails: patientDetails,
      });
      WeekTimeSlotsRef?.current?.scrollIntoView();
    }, 10);
    setDataPush(false);
  };

  const seeMoreScrollToTop = (visible: boolean) => {
    if (visible) WeekTimeSlotsRef?.current?.scrollIntoView();
  };

  const testone = () => {
    setPageSection("TIMESLOT");
    setTimeout(() => {
      setSelectedDoctor(undefined);
      setSelectedSlot(undefined);
       WeekTimeSlotsRef?.current?.scrollIntoView();
      setNextButton(true);
    }, 10);
  };

  const setTimeslotsExecution = () => {
    //setExecuteOnce(false);
    setExecuteAvailOnce(false);
  };

  const setApptData = (data: any) => {
    if (isMobile) {
      setPatientType(data.patientType);
      setSelectedDoctor(data.doctor);
      setSelectedSlot(data.timeSlot);
      setEyeExam(data.eyeExam);
      setPatientDetails(data.patientDetails);
      dispatch(
        setAppointmentData({
          status: true,
          office: officeForThisAppointment,
          doctor: data.doctor,
          timeSlot: data.timeSlot,
          patientType: data.patientType,
          eyeExam: data.eyeExam,
          patientDetails: data.patientDetails,
          lastRequestUrl: searchDate,
        })
      );
    }
    /*
    office: officeForThisAppointment,
    doctor: selectedDoctor,
    timeSlot: selectedSlot,
    patientType: patientType,
    eyeExam: eyeExam,
    patientDetails: patientDetails,
    lastRequestUrl: searchDate,
    */
  };
  const getDateUSFormat = (brithDate: string) => {
    const dob = brithDate.split("-");
    return dob[1] + "/" + dob[2] + "/" + dob[0];
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const patientDetailsValid = (patientDetails: any) => {
    let isValid = false;
    if (isValidPatientName(patientDetails.firstName, nameMaxLength)) {
      isValid = true;
    } else {
      return false;
    }
    if (isValidPatientName(patientDetails.lastName, nameMaxLength)) {
      isValid = true;
    } else {
      return false;
    }
    if (
      patientDetails.email &&
      typeof isEmail(patientDetails.email) === "boolean" &&
      typeof isValidTLDLength(patientDetails.email) === "boolean" &&
      typeof acceptableCharacters(patientDetails.email) === "boolean"
    ) {
      isValid = true;
    } else {
      return false;
    }
    if (
      patientDetails.phoneNumber &&
      typeof isValidPhoneNumber(patientDetails.phoneNumber) === "boolean"
    ) {
      isValid = true;
    } else {
      return false;
    }
    if (patientDetails.dateOfBirth) {
      if (selectedDoctor?.offersVEH) {
        if (
          officeForThisAppointment.ageRestrictVEH &&
          typeof isValidDOBRestrictVEH(
            getDateUSFormat(patientDetails.dateOfBirth)
          ) === "boolean"
        ) {
          isValid = true;
        } else if (
          !officeForThisAppointment.ageRestrictVEH &&
          typeof isValidDateOfBirthVEH(
            getDateUSFormat(patientDetails.dateOfBirth)
          ) === "boolean"
        ) {
          isValid = true;
        } else {
          isValid = false;
        }
      } else if (
        typeof isValidDateOfBirth(
          getDateUSFormat(patientDetails.dateOfBirth)
        ) === "boolean"
      ) {
        isValid = true;
      } else {
        isValid = false;
      }
    } else {
      isValid = false;
    }
    return isValid;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const isFormValidation = (data: any) => {
    if (
      officeForThisAppointment &&
      data.patientType &&
      data.selectedSlot &&
      data.selectedDoctor &&
      data.eyeExam &&
      patientDetailsValid(data.patientDetails)
    ) {
      setNextButton(false);
    } else {
      setNextButton(true);
    }
    dispatch(
      setAppointmentData({
        status: true,
        office: officeForThisAppointment,
        doctor: data.selectedDoctor,
        timeSlot: data.selectedSlot,
        patientType: data.patientType,
        eyeExam: data.eyeExam,
        patientDetails: data.patientDetails,
        lastRequestUrl: searchDate,
      })
    );
  };

  const updatePatient = (fieldValue: any) => {    
    if (pageSection === "TIMESLOT") setPageSection("PATIENT");
    
    const pDetails = cloneDeep(patientDetails);
    //setTimeout(() => {
    if (fieldValue?.field === "firstName") {
      pDetails.firstName = fieldValue?.value;
    }
    if (fieldValue?.field === "lastName") {
      pDetails.lastName = fieldValue?.value;
    }
    if (fieldValue?.field === "phoneNumber") {
      pDetails.phoneNumber = fieldValue?.value;
    }
    if (fieldValue?.field === "email") {
      pDetails.email = fieldValue?.value;
    }
    if (fieldValue?.field === "dateOfBirth") {
      pDetails.dateOfBirth = fieldValue?.value;
    }
    if (fieldValue?.field === "smsOptInNotices") {
      pDetails.smsOptInNotices = fieldValue?.value;
    }
    if (fieldValue?.field === "smsOptInPromos") {
      pDetails.smsOptInPromos = fieldValue?.value;
    }
    setPatientDetails(pDetails);
    isFormValidation({
      eyeExam: eyeExam,
      patientType: patientType,
      selectedDoctor: selectedDoctor,
      selectedSlot: selectedSlot,
      patientDetails: pDetails,
    });
    //}, 10);
  };

  useEffect(() => {
    const handleScroll = () => {
      const winScroll =
        document.body.scrollTop || document.documentElement.scrollTop;
      const height =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scrolled = (winScroll / height) * 100;
      setScrollPercentage(scrolled);
      if (pageSection !== "TIMESLOT" && scrolled < 70) {        
        setPageSection("TIMESLOT");
      }
    };

    window.addEventListener("scroll", handleScroll);

    // 🧼 Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [pageSection]); // ← empty dependency array = run once on mount

  useEffect(() => {
    if (!isDesktop || !stickyActive) {
      setStickyPosition(undefined);
      return;
    }

    const updateStickyPosition = () => {
      if (
        !stickySectionRef.current ||
        !stickyRailRef.current
      ) {
        setStickyPosition({
          top: DEFAULT_STICKY_TOP,
        });
        return;
      }

      const stickyHeight = stickyRailRef.current.getBoundingClientRect().height;
      const sectionTop =
        stickySectionRef.current.getBoundingClientRect().top + window.scrollY;
      const stopAnchorTop = reviewTooltipRef.current
        ? reviewTooltipRef.current.getBoundingClientRect().top + window.scrollY
        : reviewActionRef.current
          ? reviewActionRef.current.getBoundingClientRect().top + window.scrollY
          : desktopEmailRowRef.current
            ? desktopEmailRowRef.current.getBoundingClientRect().bottom +
              window.scrollY
            : null;

      setStickyPosition(
        getStickyPosition({
          isDesktop,
          isStickyActive: stickyActive,
          scrollY: window.scrollY,
          sectionTop,
          stickyHeight,
          stopAnchorTop,
        })
      );
    };

    updateStickyPosition();
    window.addEventListener("scroll", updateStickyPosition);
    window.addEventListener("resize", updateStickyPosition);

    return () => {
      window.removeEventListener("scroll", updateStickyPosition);
      window.removeEventListener("resize", updateStickyPosition);
    };
  }, [
    isDesktop,
    stickyActive,
    selectedDoctor,
    selectedSlot,
    patientDetails,
    screenSize,
  ]);

  React.useEffect(() => {
    if (!dataPush) {
      if (
        selectedSlot &&
        selectedDoctor &&
        eyeExam &&
        patientType &&
        patientDetailsValid(patientDetails)
      ) {
        setNextButton(false);
        setDataPush(true);
        dispatch(
          setAppointmentData({
            status: true,
            office: officeForThisAppointment,
            doctor: selectedDoctor,
            timeSlot: selectedSlot,
            patientType: patientType,
            eyeExam: eyeExam,
            patientDetails: patientDetails,
            lastRequestUrl: searchDate,
          })
        );
      } else {
        setNextButton(true);
        setDataPush(false);
      }
    }
  }, [
    eyeExam,
    officeForThisAppointment,
    patientType,
    selectedDoctor,
    selectedSlot,
    patientDetails,
    dispatch,
    searchDate,
    patientDetailsValid,
    dataPush,
    examType,
  ]);

  const moveToNext = () => {
    const activeElement = document.activeElement as HTMLElement | null;
    if (activeElement?.blur) {
      activeElement.blur();
    }
    window.getSelection?.()?.removeAllRanges();
    window.requestAnimationFrame(() => {
      setShowReview(true);
    });
  };

  const closeReview = () => {
    setShowReview(false);
  }

  const onRescheduleConflict = React.useCallback(() => {
    setShowReview(false);
    setPageSection("TIMESLOT");
    seteditSectionModal("timeSlot");
    setSelectedDoctor(undefined);
    setSelectedSlot(undefined);
    setVehSelectedSlot(undefined);
    setNextButton(true);
    setExecuteOnce(false);
    setExecuteAvailOnce(false);
    dispatch(resetTimeSlots());
    setTimeout(() => {
      WeekTimeSlotsRef?.current?.scrollIntoView();
    }, 10);
  }, [dispatch]);

  const [checked, setChecked] = React.useState(false);

  const handleChange = () => {
    setChecked(!checked);
  };

  React.useEffect(() => {
    if (!executeAvailOnce && isSlotLoaded) {
      const availabilityDoctorDetails: any = {};
      for (let i = 0; i < doctors.length; i++) {
        availabilityDoctorDetails[doctors[i]["id"]] = null;
      }

      const nextWeekAvailDate = isMobile
        ? dayjs(searchDate).add(4, "day")
        : dayjs(searchDate).add(6, "day");
      for (const slotDetails of timeslots) {
        const doctorId = slotDetails.doctorId;
        if (nextWeekAvailDate.isBefore(slotDetails.date)) {
          if (availabilityDoctorDetails[doctorId] === null) {
            availabilityDoctorDetails[doctorId] = slotDetails.date;
          } else if (
            availabilityDoctorDetails[doctorId] !== null &&
            dayjs(availabilityDoctorDetails[doctorId]).isAfter(slotDetails.date)
          ) {
            availabilityDoctorDetails[doctorId] = slotDetails.date;
          }
        }
      }
      const officeAvail = {
        officeId: officeId,
        body: {
          loaded: true,
          doctors: availabilityDoctorDetails,
        },
      };
      dispatch(setOfficeAvailability(officeAvail));
    }
  }, [
    isSlotLoaded,
    searchDate,
    doctors,
    timeslots,
    officeId,
    dispatch,
    executeAvailOnce,
  ]);

  const aria1 = {
    labelledby: "appointment-exam-details-modal-label-restrict",
    describedby: "appointment-exam-details-modal-description-restrict",
  };
  /*
  const sortNearbyOffices = [nearbyOffices].sort(function (a, b) {
    return (
      nearbyOfficesAvailabilitySlots[b.id]["total"] -
      nearbyOfficesAvailabilitySlots[a.id]["total"]
    );
  }); */
  const sortNearbyOffices = [...nearbyOffices].sort(function (a, b) {
    return (
      nearbyOfficesAvailabilitySlots[b.id]["total"] -
      nearbyOfficesAvailabilitySlots[a.id]["total"]
    );
  });
  const promoteFeatureOffice = sortNearbyOffices.filter(
    (nearby) => !nearby.doNotPromote
  );

  const featureOffice =
    promoteFeatureOffice.length > 0 ? promoteFeatureOffice[0] : null;
  //console.log(isLoading);
  //console.log(nearbyOfficesAvailabilitySlots);
  //console.log(sortNearbyOffices);
  return (
    <Layout office={officeForThisAppointment} scheduleBanner={true}>
      <div className={styles.container}>
        <ReviewModal
        className={styles.modalReview}
        aria={aria}
        isOpen={showReview}
        closeOnOverlayClick={false}
        hideClose={true}
      >
        <div className={styles.reviewModal}>
          <div>
            <img
              className={styles.closeIcon}
              onClick={closeReview}
              src={closeIcon}
              alt="close"
            />
          </div>
          <AppointmentReviewPopUpV2 
            selectedOffice={officeForThisAppointment}
            selectedPatient={patientDetails} 
            selectedDoctor={selectedDoctor}
            selectedSlot={selectedSlot}
            closeReview={closeReview}
            seeMoreScrollToTop={testone}
            onPatientEdit={onPatientEdit}
            seteditSectionModal={seteditSectionModal}
            onRescheduleConflict={onRescheduleConflict}
          />
        </div>
      </ReviewModal>
        <Modal
          className={styles.vehModal}
          aria={aria1}
          isOpen={restrictVehTerms}
          closeOnOverlayClick={false}
          hideClose={true}
        >
          <div className={styles.restrictVEHContent}>
            Please note, this doctor conducts remote in-office exams. At this
            time remote exams are only available for existing MyEyeDr. patients.
          </div>
          <div>
            <Button
              text="I AM AN EXISTING PATIENT"
              size="large"
              onClick={() => {
                onSelectionPatientType(
                  "patientType",
                  PatientReturnStatus.Returning
                );
                setRestrictVehTerms(false);
              }}
              className={styles.buttonRestrict}
            />
            <Button
              text="No, I’d like to choose a different doctor"
              size="large"
              role={ButtonRole.Ghost}
              onClick={() => {
                setRestrictVehTerms(false);
                setVehDoctorTerms(false);
                setSelectedDoctor(undefined);
                setSelectedSlot(undefined);
                setVehSelectedSlot(undefined);
                setPatientType(undefined);
                setChecked(false);
                setTimeout(() => {
                  WeekTimeSlotsRef?.current?.scrollIntoView();
                }, 10);
              }}
              className={styles.buttonRestrict}
            />
          </div>
        </Modal>
        
        <Modal
          className={styles.newvehModal}
          contentclassName={styles.conClass}
          aria={aria}
          isOpen={vehDoctorTerms}
          closeOnOverlayClick={false}
          hideClose={true}
        >
        <div className={styles.vehContent}>
          <div>
            <p className={styles.nvehheader}>
              <img
                className={styles.iconSmile}
                src={iconSmile}
                alt=""
              />{" "}Same great care, more flexible</p>
          </div>
          <div>
            <img
              className={styles.imgPatient}
              src={vehPatientImg}
              alt=""
            />
          </div>
          
          <div>
            <p className={styles.newP1}>
              <span>
                  You’ll come into our office and get a full comprehensive eye exam with a licensed optometrist who will video call in.
              </span>
            </p>
          </div>

          <div className={styles.newL1}>
            <p>Some important things to note about this exam:</p>
          </div>

          <div className={styles.newL2}>
            <ul>
              {officeForThisAppointment.restrictVEH && (
                <>
                  <li>
                    <div className={styles.listContainer}>
                      <div className={styles.listImg}>
                        <img
                          className={styles.iconBaby}
                          src={iconReturn}
                          alt=""
                        />
                      </div>
                      <div className={styles.listText}>
                        Patients must be existing MyEyeDr. patients, not new patients.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className={styles.listContainer}>
                      <div className={styles.listImg}>
                        <img
                          className={styles.iconBaby}
                          src={iconBaby}
                          alt=""
                        />
                      </div>
                      <div className={styles.listText}>
                        {officeForThisAppointment.ageRestrictVEH && ( <>Patients must be between 18-55 years old. </>)}
                        {!officeForThisAppointment.ageRestrictVEH && ( <>Patients must be at least 10 years old. </>)}
                      </div>
                    </div>
                  </li>
                </>
              )}
              {!officeForThisAppointment.restrictVEH && (
                <li>
                  <div className={styles.listContainer}>
                    <div className={styles.listImg}>
                      <img
                        className={styles.iconBaby}
                        src={iconBaby}
                        alt=""
                      />
                    </div>
                    <div className={styles.listText}>
                      {officeForThisAppointment.ageRestrictVEH && ( <>Patients must be between 18-55 years old.</>)}
                      {!officeForThisAppointment.ageRestrictVEH && ( <>Patients must be at least 10 years old. </>)}
                    </div>
                  </div>
                </li>
              )}


              <li>
                <div className={styles.listContainer}>
                  <div className={styles.listImg}>
                    <img
                      className={styles.iconBaby}
                      src={iconClip}
                      alt=""
                    />
                  </div>
                  <div className={styles.listText}>
                    <b>We recommend retinal imaging to all our patients.</b> Retinal imaging lets your doctor see the inside and back of your eye to catch issues early, and it’s required for this exam. The fee for retinal imaging is $44.
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div>
            <Button
              text="Accept & Schedule"
              size="large"
              onClick={() => {
                setVehDoctorTerms(false);
                setSelectedSlot(vehSelectedSlot);
                setPatientType(undefined);
                setChecked(false);
                dispatch(
                  updateSelectedAppointment({
                    officeId,
                    officeUid,
                    ...vehSelectedSlot,
                  })
                );
                setTimeout(() => {
                  examTypeRef?.current?.scrollIntoView();
                }, 10);
              }}
              className={styles.buttonAcc}
            /> 
            </div>
            <div className={styles.btnGoContainer}>
              <div
                onClick={() => {
                  setVehDoctorTerms(false);
                  setSelectedDoctor(undefined);
                  setSelectedSlot(undefined);
                  setVehSelectedSlot(undefined);
                  setChecked(false);
                }}
                className={styles.buttonGo}> 
                <img
                  className={styles.iconBack}
                  src={arrowLeft}
                  alt="Go Back"
                />{" "}Go Back
              </div>
          </div>
        </div>
        </Modal>
        <div ref={stickySectionRef} className={styles.stickySection}>
          <div ref={WeekTimeSlotsRef} className={styles.firstContainer}>
            <WeekTimeSlots
              key={"weektime1"}
              office={officeForThisAppointment}
              featureOffice={featureOffice}
              showFeatureOffice={showFeatureOffice}
              doctors={doctors}
              searchDate={searchDate}
              onSelection={onSelectionTimeSlot}
              seeMoreScrollToTop={seeMoreScrollToTop}
              selectedSlot={selectedSlot}
              isEditForm={isEditForm}
              setTimeslotsExecution={setTimeslotsExecution}
              newDateArr={newDateArr}
              pageSection={pageSection}
              newDesign={newDesign}
              slotMetaData={slotMetaData}
              screenSize={screenSize}
              firstAvailDocs={firstAvailDocs}
              useClassicStartLayout={useClassicStartAvailabilityLayout}
            />
            <div
              ref={stickyRailRef}
              className={
                stickyActive
                  ? cx(styles.rightContainer, styles.stickyContainer)
                  : styles.rightContainer
              }
              style={
                stickyActive && stickyPosition !== undefined
                  ? ({
                      "--sticky-top-offset": `${stickyPosition.top}px`,
                    } as React.CSSProperties)
                  : undefined
              }
            >
              <OfficeCard
                office={officeForThisAppointment}
                selectedSlot={selectedSlot}
                isEditForm={isEditForm}
              />
              <TrustBuildCard />
              {selectedDoctor && selectedSlot && (
                <DoctorCard
                  doctor={selectedDoctor}
                  selectedOffice={officeForThisAppointment}
                  slot={selectedSlot}
                  searchDate={searchDate}
                  onClick={onEditTimeSlot}
                  isEditForm={isEditForm}
                />
              )}
              {selectedSlot === undefined && (
                <NearbyOffice
                  nearbyOffices={sortNearbyOffices}
                  availabilitySlots={nearbyOfficesAvailabilitySlots}
                  onClick={onEditTimeSlot}
                  patientReturnStatus={patientReturnStatus}
                  examType={examType}
                  isEditForm={false}
                  isMobile={false}
                  isLoading={isLoading}
                  newDesign={newDesign}
                  useClassicStartLayout={useClassicStartAvailabilityLayout}
                />
              )}
            </div>
          </div>
          <div ref={examTypeRef}>
            <AppointmentExamDetails
              office={officeForThisAppointment}
              eyeExam={eyeExam}
              onSelection={onSelectionExamType}
            />
          </div>
          <div ref={patientTypeRef}>
            <AppointmentSelectReturnStatus
              patientType={patientType}
              doctor={selectedDoctor}
              office={officeForThisAppointment}
              onSelection={onSelectionPatientType}
              onRestrictVEHSelection={onRestrictVEHSelection}
            />
          </div>
          <div ref={patientDetailsRef}>
            <AppointmentAccountSetup
              office={officeForThisAppointment}
              doctor={selectedDoctor}
              patient={patientDetails}
              updatePatient={updatePatient}
              isMobileView={false}
              desktopEmailRowRef={desktopEmailRowRef}
              actionSlotRef={reviewActionRef}
            >
              <div className={styles.buttonWrapper}>
                <div className={styles.container}>
                  <div
                    ref={reviewTooltipRef}
                    className={cx(
                      [styles.tooltipContainer, styles.tooltipPositionTop],
                      {
                        [styles.tooltipVisible]: nextButton,
                      }
                    )}
                  >
                    <div className={styles.contentContainer}>
                      <div className={styles.content}>
                        {selectedDoctor && (
                          <div className={styles.classWhite}>
                            <img
                              className={styles.iconCircle}
                              src={successCircle}
                              alt="success"
                            />{" "}
                            Time Slot selected{" "}
                          </div>
                        )}
                        {!selectedDoctor && (
                          <div className={styles.classRed}>
                            <img
                              className={styles.iconCircle}
                              src={errorCircle}
                              alt="Error"
                            />{" "}
                            Time Slot not selected
                          </div>
                        )}
                        {eyeExam && (
                          <div className={styles.classWhite}>
                            <img
                              className={styles.iconCircle}
                              src={successCircle}
                              alt="success"
                            />{" "}
                            Eye Exam selected{" "}
                          </div>
                        )}
                        {!eyeExam && (
                          <div className={styles.classRed}>
                            <img
                              className={styles.iconCircle}
                              src={errorCircle}
                              alt="Error"
                            />{" "}
                            Eye Exam not selected
                          </div>
                        )}
                        {patientType && (
                          <div className={styles.classWhite}>
                            <img
                              className={styles.iconCircle}
                              src={successCircle}
                              alt="success"
                            />{" "}
                            Patient Type selected{" "}
                          </div>
                        )}
                        {!patientType && (
                          <div className={styles.classRed}>
                            <img
                              className={styles.iconCircle}
                              src={errorCircle}
                              alt="Error"
                            />{" "}
                            Patient Type not selected
                          </div>
                        )}
                        {patientDetailsValid(patientDetails) && (
                          <div className={styles.classWhite}>
                            <img
                              className={styles.iconCircle}
                              src={successCircle}
                              alt="success"
                            />{" "}
                            Patient Details updated
                          </div>
                        )}
                        {!patientDetailsValid(patientDetails) && (
                          <div className={styles.classRed}>
                            <img
                              className={styles.iconCircle}
                              src={errorCircle}
                              alt="Error"
                            />{" "}
                            Patient Details not updated
                          </div>
                        )}
                      </div>
                      <div></div>
                    </div>
                  </div>
                  <div>
                    <Button
                      className={isV3 ? styles.footerNextBtnCustom : styles.footerNextBtn}
                      text={isV3 ? "Review Details" : "REVIEW DETAILS"}
                      onClick={moveToNext}
                      role={ButtonRole.Standard}
                      disabled={nextButton}
                    />
                  </div>
                </div>
              </div>
            </AppointmentAccountSetup>
          </div>
        </div>
        <Footer
          formattedPhone={formattedPhone}
          showSMSContent={true}
          useV3StartPageCopy={isV3}
        />
        <FooterPortal />
      </div>
      <MobileView
        doctors={doctors}
        officeId={officeId}
        examType={examType}
        nearbyOffices={sortNearbyOffices}
        featureOffice={featureOffice}
        showFeatureOffice={showFeatureOffice}
        availabilitySlots={nearbyOfficesAvailabilitySlots}
        patientReturnStatus={patientReturnStatus}
        selectedOffice={officeForThisAppointment}
        searchDate={searchDate}
        setSearchDate={setSearchDate}
        setShowReview={setShowReview}
        setTimeslotsExecution={setTimeslotsExecution}
        setApptData={setApptData}
        patientDetailsValid={patientDetailsValid}
        onRestrictVEHSelection={onRestrictVEHSelection}
        newDateArr={newDateArr}
        newDesign={newDesign}
        slotMetaData={slotMetaData}
        screenSize={screenSize}
        editSectionModal={editSectionModal}
        firstAvailDocs={firstAvailDocs}
      />
    </Layout>
  );
};

export const AppointmentBookingStartV2: React.FC = () => {
  return (
    <WithOffice version={1}>
      {({ office, officeId }) => (
        <WithOfficeDoctors officeId={officeId}>
          {({ doctors }) => (
            <UnconnectedAppointmentBookingStart
              key={officeId}
              officeForThisAppointment={office}
              officeId={officeId}
              doctors={doctors}
            />
          )}
        </WithOfficeDoctors>
      )}
    </WithOffice>
  );
};
